const json = [
  {
    name: "Text",
    component: "TextWidget",
    editor: "<p>Welcome to Signage 🎉</p>",
    icon: "text.svg",
    auto_height: true,
    width: 434,
    height: 60,
    min_width: 50,
    min_height: 42,
    color: "red",
  },
  {
    name: "Image",
    component: "ImageWidget",
    icon: "image.svg",
    src: "",
    width: 334,
    height: 200,
    min_width: 15,
    min_height: 15,
  },
  {
    name: "Weather",
    component: "WeatherWidget",
    icon: "weather.svg",
    width: 292,
    height: 168,
    min_width: 150,
    min_height: 100,
    type: "horizontal",
    styles: {
      fontFamily: "Source Sans Pro",
      color: "rgb(255, 255, 255)",
      backgroundColor: "#3e94ff",
      borderColor: "#3e94ff",
      borderWidth: "2px",
      "border-style": "solid",
    },
    settings: {
      timezone: {
        value: "Europe/Lisbon",
        name: "Porto, Portugal",
      },
      offsetDays: 0,
    },
    format: 0,
    style: 1,
  },
  {
    name: "Video",
    component: "VideoWidget",
    icon: "video.svg",
    file: "",
    src: "",
    width: 350,
    height: 200,
    min_width: 200,
    min_height: 200,
  },
  {
    name: "Shapes",
    component: "ShapesWidget",
    icon: "shapes.svg",
    width: 250,
    height: 250,
    min_width: 15,
    min_height: 15,
    styles: {
      background: "#cfe2f3",
      "border-color": "black",
      borderWidth: "1px",
      borderColor: "black",
      stroke: 0,
    },
    type: "square",
  },
  {
    name: "Date",
    component: "DateWidget",
    icon: "calendar.svg",
    width: 180,
    height: 80,
    min_width: 95,
    min_height: 27,
    type: "default",
    styles: {
      fontFamily: "Source Sans Pro",
      fontSize: "32px",
      color: "rgb(0,0,0)",
      background: "rgb(255,255,255)",
      borderWidth: "0px",
      borderStyle: "solid",
      borderColor: "black",
    },
    settings: {
      timezone: {
        value: "Europe/Lisbon",
        name: "Porto, Portugal",
      },
    },
  },
  {
    name: "Clock",
    component: "ClockWidget",
    icon: "clock.svg",
    width: 200,
    height: 200,
    min_width: 60,
    min_height: 60,
    styles: {
      borderColor: "black",
      backgroundColor1: "white",
      fontColor: "black",
    },
    settings: {
      timezone: {
        value: "Europe/Lisbon",
        name: "Porto, Portugal",
      },
    },
    type: "Classic",
    format: 0,

    typeClock: "1",
  },
  {
    name: "Flights",
    component: "FlightsWidget",
    icon: "flights.svg",
    width: 850,
    height: 470,
    min_width: 740,
    min_height: 470,
    settings: {
      airport: { value: "OPO", name: "Francisco Sa Carneiro Airport" },
      minHours: -1,
      maxHours: 6,
      idtype: "icao",
      time: 5,
      fontSize: "Medium",
    },
    styles: {
      fontFamily: "Source Sans Pro",
    },
    type: 1,
    typeTheme: 2,
    theme: {
      primary: "#c7ff5c",
      secondary: "#212121",
      tertiary: "#2c364a",
      txt_primary: "#212121",
      txt_secondary: "#FFFFFF",
    },
    format: 0,
  },
  {
    name: "WayFinder",
    component: "WayFinderWidget",
    icon: "wayfinder.svg",
    width: 870,
    height: 430,
    min_width: 450,
    min_height: 180,
    styles: {
      fontSize: "medium",
      fontFamily: "Source Sans Pro",
    },
    settings: {
      type: "today",
      next: 8,
      time: 10,
      location: false,
    },
    wayfinder: null,
    theme: {
      primary: "#ff6d6d",
      secondary: "#24b472",
      txt_primary: "#FFFFFF",
      txt_secondary: "#FFFFFF",
    },
    format: 0,
  },
  {
    name: "Table",
    component: "TableWidget",
    icon: "table.svg",
    editor: `<table>
    <tr>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    </table>`,
    width: 500,
    height: 500,
    auto_height: true,
    min_width: 50,
    min_height: 50,
  },
  {
    name: "Internet",
    component: "IFrameWidget",
    icon: "iframe.svg",
    width: 800,
    height: 600,
    min_width: 500,
    min_height: 500,
    settings: {
      url: '',
    },
  },
  {
    name: "TV",
    component: "TVWidget",
    icon: "tv.svg",
    width: 500,
    height: 300,
    min_width: 500,
    min_height: 300,
    settings: {
      channels: [],
    },
  },
  {
    name: "Islamic Calendar",
    component: "IslamicCalendarWidget",
    icon: "islamic.svg",
    width: 850,
    height: 769,
    min_width: 460,
    min_height: 769,  
    styles: {
      fontFamily: "Source Sans Pro",
    },
    theme: {
      primary: "#212121",
      secondary: "#222732",
      txt_primary: "#EEB9B9",
      txt_secondary: "#FFFFFF",
    },
    settings: {
      latitude: "41",
      longitude: "-8",
      transition: "5",
    }
  },
  {
    name: "Rates",
    component: "RatesWidget",	
    icon: "rates.svg",
    width: 850,
    height: 380,
    min_width: 360,
    min_height: 220,  
    styles: {
      fontSize: "medium",
      fontFamily: "Source Sans Pro",
    },
    theme: {
      highlight: "#C7FF5C",
      primary: "#212121",
      secondary: "#222732",
      txt_primary: "#212121",
      txt_secondary: "#FFFFFF",
    },
    settings: {
      currency: "EUR",
      currencies: ["USD", "GBP", "AUD"],
      source: "FloatingRates",
      transition: "5",
      type: "default"
    }    
  },
  {
    name: "Media Playlist",
    component: "MediaPlaylistWidget",
    icon: "playlists.svg",
    width: 500,
    height: 500,
    min_width: 150,
    min_height: 150,
    settings: {
      playlist: '',
      playlist_type: 'Image'
    },
  },
];

// Add multiple repeated fields to widgets
const widgets = json.map((item) => {
  return {
    ...item,
    auto_height: item.auto_height ? item.auto_height : false,
    resizable: item.resizable ? item.resizable : true,
    styles: item.styles ? item.styles : {},
    min_height: item.min_height ? item.min_height : 50,
    min_width: item.min_width ? item.min_width : 50,
    angle: 0,
    is_dragging: false,
    locked: false,
    scale: 1,
    admin_locked: false
  };
});

export default widgets;
